import React from "react"
import styles from "./styles.scss"
import MenuBar from "components/MenuBar"
import image from "images/office.jpg"

class Hero extends React.Component {
  render() {
    const { heroDescription } = this.props

    return (
      <section
        className={styles.container}
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className={styles.wrapper}>
          <MenuBar variant="white" />
          <div className={styles.contentContainer}>
            <h1 className={styles.title}>Jobba på SAITS</h1>
            <p className={styles.description}>{heroDescription}</p>
          </div>
        </div>
      </section>
    )
  }
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/JobDescription/Hero/index.jsx